import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { assign as _assign, get as _get, forOwn as _forOwn } from 'lodash-es';
import { ProductPriceString } from '../utils/ProductPriceString';

import PopupCollection from '../popups/PopupCollection';

import CompatioAnalytics from '../../api/CompatioAnalytics';

import logoImgText from '../../styles/images/loading.png';

const trackAnchorClick = data => {
  // console.log(data,'data')
  CompatioAnalytics.track(CompatioAnalytics.events.collectionProductView, {
    product_name: data.productName,
    product_url: data.product_url,
    product_id: data.productID,
    price: data.price,
    click_action: CompatioAnalytics.clicks.collectionClickProduct,
  });
};

let debounceFlag = true;
const historyCount = localStorage.getItem('pageCountHistory');
let pageCoutCheck = [];
let pageCoutCheckDefault = [];
let pageDefaultHeight = [];
class ProductList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentProductsPerPage:
        historyCount != null
          ? +historyCount + props.productsPerPage
          : props.productsPerPage,
      loading: false,
      errorMessage: null,
      products: {},
      scrollDebounce: true,
      currpageCount: localStorage.getItem(
        this.props.collectionName + 'pageCount'
      ),
    };
    this.handleShowMore = this.handleShowMore.bind(this);
    this.loadMore = this.loadMore.bind(this);
    window.addEventListener('scroll', this.loadMore);
    pageCoutCheck.push(props.productsPerPage);
    // localStorage.removeItem('pageCountHistory');
  }

  componentDidMount() {
    if (!localStorage.getItem('defaultHeight')) {
      localStorage.setItem(
        'defaultHeight',
        document.getElementById('collection-filter-product-box').clientHeight +
          'px'
      );
      localStorage.setItem('pageCountHistory', this.props.productsPerPage);
    }
    // pageDefaultHeight.push(
    //   document.getElementById('collection-filter-product-box').clientHeight
    // );
    // console.log(document.getElementById('xrs-products-default').clientHeight,'fasdfsdfsfsfasfasfdsfsfasf')
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('scroll', this.loadMore);
  }

  /**
   * Show additional products
   */
  handleShowMore() {
    pageCoutCheckDefault.push(this.props.productsPerPage);
    // alert(localStorage.getItem('pageCountHistory'))
    // const newProductsPerPage =
    //   pageCoutCheck[0] +
    //   pageCoutCheckDefault.length * this.props.productsPerPage;

    const newProductsPerPage =
      this.state.currentProductsPerPage + this.props.productsPerPage;
    //  console.log(this.props.productsPerPage,'this.props.productsPerPage', )
    console.log(
      this.state.currentProductsPerPage + this.props.productsPerPage,
      'this.state.currentProductsPerPage + this.props.productsPerPage',
      pageCoutCheck.length,
      pageCoutCheck[0]
    );
    // console.log(this.props.productsPerPage,this.state.currentProductsPerPage)
    pageCoutCheck.push(this.props.productsPerPage);
    // console.log(pageCoutCheck.length*this.props.productsPerPage,'pageCoutCheck')
    localStorage.setItem(
      'pageCountHistory',
      // pageCoutCheck.length * pageCoutCheck[0]
      this.state.currentProductsPerPage + this.props.productsPerPage
    );
    //  console.log(document.getElementById('collection-filter-product-box').clientHeight,'pageDefaultHeight')
    localStorage.setItem(
      'defaultHeight',
      document.getElementById('collection-filter-product-box').clientHeight +
        'px'
    );
    // console.log( document.getElementById('xrs-products-default').clientHeight + 'px', 'clientHeight');

    this.setState({
      currentProductsPerPage:
        this.state.currentProductsPerPage + this.props.productsPerPage,
    });
  }

  componentDidUpdate() {
    if (!localStorage.getItem('defaultHeight')) {
      localStorage.setItem(
        'defaultHeight',
        document.getElementById('collection-filter-product-box').clientHeight +
          'px'
      );
      localStorage.setItem('pageCountHistory', this.props.productsPerPage);
    }

    // console.log(
    //   localStorage.getItem('defaultHeight'),
    //   document.getElementById('collection-filter-product-box').clientHeight,
    //   'height data'
    // );
    // setTimeout(()=>{
    // pageDefaultHeight.push(document.getElementById('xrs-products-default').clientHeight)
    //   // console.log(document.getElementById('xrs-products-default').clientHeight,'fsdfsdfgsdfsdfsd')
    //   // localStorage.setItem('defaultHeight',  document.getElementById('xrs-products-default').clientHeight + 'px');
    //   },150)
    // localStorage.setItem('defaultHeight',  document.getElementById('xrs-products-default').clientHeight + 'px');
  }

  // handleScroll = e => {
  //   const bottom =
  //     e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
  //   console.log('called this method');
  //   if (bottom) {
  //     console.log('reached bottom');
  //   }
  // };
  loadMore() {
    // sessionStorage.removeItem("last_url", currpage);
    const wrappedElement = document.getElementById('loadButton');
    if (
      wrappedElement &&
      wrappedElement.getBoundingClientRect().bottom <= window.innerHeight + 1
    ) {
      if (debounceFlag) {
        debounceFlag = false;
        this.handleShowMore();
        setTimeout(() => {
          this.handleShowMore();
        }, 200);
      }
    } else {
      debounceFlag = true;
    }
  }
  checkIfSalePresent(singleProduct) {
    // console.log(singleProduct,'singleProduct')
    let IsOnSale = false;
    if (singleProduct.variants) {
      if (
        singleProduct &&
        singleProduct.variants.length === 1 &&
        singleProduct.variants[0].price <
          singleProduct.variants[0].compare_at_price &&
        singleProduct.variants[0].compare_at_price != 0
      ) {
        IsOnSale = true;
      }
      if (singleProduct && singleProduct.variants.length > 1) {
        //let ifAnyVariantOnSale = false;
        const discountedVariant = singleProduct.variants.find(element => {
          return (
            element.price < element.compare_at_price &&
            element.compare_at_price != 0
          );
        });
        if (discountedVariant != undefined) IsOnSale = true;
      }
    }
    return IsOnSale;
  }

  getPriceString(singleProduct) {
    if (
      singleProduct &&
      singleProduct.variants.length === 1 &&
      singleProduct.variants[0].price <
        singleProduct.variants[0].compare_at_price &&
      singleProduct.variants[0].compare_at_price != 0
    ) {
      return (
        <>
          <ProductPriceString
            saleMaxPrice={singleProduct.compare_at_price}
            MaxPrice={singleProduct.price}
            price={singleProduct.priceNew}
            compareAtPrice={singleProduct.variants[0].salePrice}
            currency={singleProduct.currency}
            endingString={parseFloat(
              singleProduct.variants[0].compare_at_price -
                singleProduct.salePrice
            ).toFixed(2)}
          />
        </>
      );
    }

    if (singleProduct && singleProduct.variants.length > 1) {
      //let ifAnyVariantOnSale = false;
      const discountedVariant = singleProduct.variants.find(element => {
        return (
          element.price < element.compare_at_price &&
          element.compare_at_price != 0
        );
      });
      if (discountedVariant != undefined)
        return (
          <>
            <ProductPriceString
              price={discountedVariant.priceNew}
              compareAtPrice={discountedVariant.compareOriginalPrice}
              currency={discountedVariant.currency}
              middleString={`from `}
            />
          </>
        );
    }

    return (
      <>
        <ProductPriceString
          price={singleProduct.priceNew}
          compareAtPrice={singleProduct.variants[0].compareOriginalPrice}
          currency={singleProduct.currency}
        />
      </>
    );
  }

  render() {
    // const pageScrollProductWise = localStorage.getItem('pageHistory');
    // console.log(pageScrollProductWise,'pageScrollProductWise')
    const handelClick = e => {
      localStorage.setItem('pageHistory', e);
    };
    const handleAddClick = singleProduct => {
      // console.log(singleProduct)
      this.props.setCollectionProductPop(singleProduct);
      this.props.SetShowOptions(true);
    };
    const toggleBundler = () => {
      this.props.SetShowOptions(false);
    };
    const getDefaultBacking = () => {
      const backingdata = _get(
        window,
        'compatioConfig.compatibleProducts.backingData'
      );
      return backingdata[0] && backingdata[0].variantId;
    };
    let currentProductCount = 0;

    let products = this.props.filteredData;
    if (this.state.loading)
      return (
        <h3 className="xrs-loading">
          <FormattedMessage
            id="ProductList.loading"
            defaultMessage="Loading products..."
          />
        </h3>
      );
    if (this.state.errorMessage)
      return <h3 className="xrs-error">{this.state.errorMessage}</h3>;
    if (!products.length)
      return (
        <p className="xrs-loading">
          {/* <FormattedMessage
            id="ProductList.no_products_inCollection"
            defaultMessage="No products found"
          /> */}
          No Available Products Found..!
          <br />
          There are no products that match the filter criteria. <br />
          Try removing filter criteria to discover new products.
        </p>
      );

    const productList = (
      <div
        className="collection-filter-product-box"
        id="collection-filter-product-box"
      >
        {products.map(singleProduct => {
          currentProductCount++;
          // console.log(singleProduct, +this.state.currpageCount);
          // if(currentProductCount < ++this.state.currpageCount){
          //   if (currentProductCount > ++this.state.currpageCount ) {
          //     return null;
          //   }
          // }else{

          // }
          if (currentProductCount > this.state.currentProductsPerPage) {
            return null;
          }
          localStorage.setItem(
            this.props.collectionName + 'pageCount',
            currentProductCount
          );
          //  console.log(products.length,++this.state.currpageCount , +this.state.currpageCount + this.state.currentProductsPerPage, this.state.currentProductsPerPage)

          return (
            <>
              <div className="collection-list-product-wrap grid-product__content">
                {/* {singleProduct.product_url} */}

                <div className="collection-filter-value-label">
                  <div className="xrs-product__image-wrapper">
                    <div className="info collectionfiltersale">
                      {this.checkIfSalePresent(singleProduct) ? (
                        <label className="sale">Sale</label>
                      ) : null}
                    </div>
                    <div className="xrs-product__image-container collectionfilterhover ">
                      {/* {pageScrollProductWise == singleProduct.productID ? (
                        <span id={pageScrollProductWise}></span>
                      ) : null} */}
                      <a
                        href={singleProduct.product_url}
                        key={singleProduct.productID}
                        onClick={() => {
                          handelClick(singleProduct.productID);
                          trackAnchorClick(singleProduct);
                        }}
                      >
                        <div
                          style={{
                            backgroundImage: `url(${singleProduct.url_image})`,
                            width: '100%',
                            height: '256px',
                            backgroundSize: '100%',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                          }}
                          className={
                            singleProduct.url_image_two
                              ? 'xrs-product__image collectionfirstimg'
                              : 'xrs-product__image'
                          }
                        ></div>

                        {singleProduct.url_image_two ? (
                          <div
                            style={{
                              backgroundImage: `url(${singleProduct.url_image_two})`,
                              width: '100%',
                              height: '256px',
                              backgroundSize: '100%',
                              backgroundRepeat: 'no-repeat',
                              backgroundPosition: 'center',
                            }}
                            className="xrs-product__image collectionsecoundimg"
                          ></div>
                        ) : (
                          ''
                        )}
                      </a>
                    </div>
                    <button
                      className="quick-product__btn js-modal-open-quick-modal-7174889308335 small--hide"
                      onClick={() => {
                        handleAddClick(singleProduct);
                      }}
                    >
                      Quick View
                    </button>
                  </div>
                  <div className="collection-product-details">
                    <a
                      href={singleProduct.product_url}
                      key={singleProduct.productID}
                      onClick={() => {
                        handelClick(singleProduct.productID);
                        trackAnchorClick(singleProduct);
                      }}
                    >
                      <span
                        className="xrs-product__name"
                        data-testid="productname"
                      >
                        {singleProduct.productName}
                      </span>
                    </a>
                    <span
                      style={{ fontSize: 'small' }}
                      className="xrs-product__name_sub"
                    >
                      {singleProduct.productVendor}
                    </span>
                    {/* {this.getPriceString(singleProduct)} */}

                    <div class="grid-product__price">
                      {singleProduct.compare_at_price > singleProduct.price ? (
                        <>
                          <span class="grid-product__price--original">
                            {singleProduct.compareOriginalPrice}
                          </span>
                          <span class="class=" visually-hidden>
                            {singleProduct.priceNew}
                          </span>
                          <span
                            class="grid-product__price--savings"
                            style={{ display: 'block' }}
                          >
                            Save
                            {' ' + singleProduct.salePrice}
                          </span>
                        </>
                      ) : (
                        <div class="grid-product__price">
                          {singleProduct.priceNew}
                        </div>
                      )}
                    </div>

                    {/* <span
                    className="shopify-product-reviews-badge"
                    data-id={singleProduct.productID}
                  ></span> */}
                    <div className="yotporeview">
                      <div
                        class="yotpo bottomLine"
                        data-product-id={singleProduct.productID}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
    );

    const allProductsVisible =
      products.length <= this.state.currentProductsPerPage;
    const productShowMore = allProductsVisible ? (
      ''
    ) : (
      <>
        <div className="xrs-products__show-more-container">
          <img
            className="xrs-popup-loading"
            src={'https://d6xuy9obqhzs2.cloudfront.net/v0/' + logoImgText}
            alt="Compatio"
          />
          <button
            id="loadButton"
            className="xrs-products__show-more-button"
            onClick={this.handleShowMore}
          >
            <FormattedMessage
              id="ProductList.loading"
              defaultMessage="Loading More"
            />
          </button>
        </div>
      </>
    );

    return (
      <>
        <div
          className="xrs-products"
          id="xrs-products-default"
          // style={{
          //   minHeight: localStorage.getItem('defaultHeight')
          //     ? localStorage.getItem('defaultHeight')
          //     : null,
          // }}
        >
          {this.props.ShowOptions ? (
            <PopupCollection
              width={100}
              isOpen={this.props.ShowOptions}
              bundlerType="xrsoptions"
              toggleBundler={toggleBundler}
              parentProduct={this.props.collectionProductPop}
              parentProductSku={this.props.collectionProductPop.id}
              bundledProduct={this.props.collectionProductPop.id}
              defaultBacking={getDefaultBacking()}
            />
          ) : null}
          <div className="xrs-products__product-list">{productList}</div>
          {productShowMore}
        </div>
      </>
    );
  }
}

export default ProductList;
